import { Dispatch } from "redux";
import SponsorshipRepository, { ParamSponsorship } from "../../Repositories/SponsorshipRepository";
import { PutSponsorship } from "../../Objects/interfaces/AppInterface";

export const GET_SPONSORSHIP_BY_TEACHR = "GET_SPONSORSHIP_BY_TEACHR"
export const UPDATE_SPONSORSHIP_BY_TEACHR = "UPDATE_SPONSORSHIP_BY_TEACHR"

interface GetSponsorshipAction {
  type: typeof GET_SPONSORSHIP_BY_TEACHR;
  payload: any;
}

interface PutSponsorshipAction {
  type: typeof UPDATE_SPONSORSHIP_BY_TEACHR;
  payload: any;
}

export type GetSponsorshipActionTypes = GetSponsorshipAction;
export type PutSponsorshipActionTypes = PutSponsorshipAction;

export const getSponsorship = ({ teachr, page, limit, statut, search }: ParamSponsorship) => {
  return async (dispatch: Dispatch<GetSponsorshipActionTypes>) => {
    try {
      if (!teachr) return;
      const response = await SponsorshipRepository.getSponsorshipByTeachr({ teachr, page, limit, statut, search })
   
      dispatch({ type: GET_SPONSORSHIP_BY_TEACHR, payload: response });
    } catch (error: any) {
      console.warn("Erreur lors de la récupération des filleuls :", error);
    }
  };
};

export const putSponsorship = (data: PutSponsorship) => {
  return async (dispatch: Dispatch<PutSponsorshipActionTypes>) => {
    try {
      data.setLoad(true)
      if (!data.teachr) return;
      const statut = await SponsorshipRepository.updateSponsorship(data.teachr, data.sponsorship)
      if (statut) {
        dispatch({ type: UPDATE_SPONSORSHIP_BY_TEACHR, payload: statut });
        data.handleNext()
        data.setLoad(false)
      }
    } catch (error: any) {
      data.setLoad(false)
      console.warn("Erreur lors de la modification des filleuls :", error);
    } finally {
      data.setLoad(false)
    }
  };
};